import { useEffect, useState } from "react";
import { useGetAdTableDataMutation, useGetAdEffectivenessDropdownFilterMutation } from "../api/adEffectiveness";

export const useGetAdTable=()=>{
    const [cached, setCached] = useState(undefined);
    const [mutate,{isLoading,isError,isSuccess,data}] = useGetAdTableDataMutation();
    const resetData = () => {
        setCached(undefined);
    }
    useEffect(()=>{
        if(isSuccess){
            setCached(data?.data);
        }
    },[])
    return {
        mutate,
        isLoading,
        isError,
        isSuccess,
        cached,
        resetData
    }
}

export const useGetAdEffectivenessDropDown = ()=>{
    const [mutate,{isLoading,isError,isSuccess,data}] = useGetAdEffectivenessDropdownFilterMutation();
    return {
        mutate,
        isLoading,
        isError,
        isSuccess,
        data
    }
}